import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-file-confirmation-delete-modal',
    templateUrl: './file-confirmation-delete-modal.component.html',
    styleUrls: ['./file-confirmation-delete-modal.component.scss'],
    standalone: false
})
export class FileConfirmationDeleteModalComponent extends CfetBaseComponent {

  constructor() { super(); }

  @Input() selectedFile: string;
  @Input() openModal: string;
  @Output() modalCloseEvent = new EventEmitter<any>();

  deleteFiles (event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.modalCloseEvent.emit('DeleteFile');
      this.modalCloseEvent.emit('modalClose');
      this[modalAction] = 'close';
    }
  }
  cancelPopup (event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }

  closeDeleteFilePopup (event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click'
      || event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }
}
